import {
  Route,
  Redirect,
  RouteProps,
  RouteComponentProps,
} from "react-router-dom";
import {isAuthenticated} from "../lib/utils/auth.utils";

interface PrivateRouteProps
  extends Omit<RouteProps, "component" | "render" | "children"> {
  component: React.ComponentType<RouteComponentProps>;
  layout: React.ComponentType<{children: React.ReactNode}>;
}

const Private: React.FC<PrivateRouteProps> = ({
  component: Component,
  layout: Layout,
  ...rest
}) => {
  return (
    <Route
      {...rest}
      render={(props: RouteComponentProps) => {
        if (!isAuthenticated()) {
          // Only redirect if we're not already on the login page
          if (props.location.pathname !== "/login") {
            return (
              <Redirect
                to={{
                  pathname: "/login",
                  search:
                    props.location.pathname !== "/"
                      ? `?richiamare=${encodeURIComponent(
                          props.location.pathname +
                            (props.location.search || "")
                        )}`
                      : "",
                }}
              />
            );
          }
          return null; // or a loading state if needed
        }
        return (
          <Layout>
            <Component {...props} />
          </Layout>
        );
      }}
    />
  );
};

export default Private;
